import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.css'

export class Interstitial {

    constructor (target = '.js-interstitial', options = {}) {

        this.target = target;

        this.options = {
            delay: 20,
            scroll: null,
            ...options
        }
    }

    init() {
        this.$interstitials = document.querySelectorAll(this.target);

        this.$interstitials.forEach( $interstitial => {
            if( sessionStorage.getItem(`${$interstitial.id}`) === 'open') {
                return false;
            }

            let options = this.options;
            if ( $interstitial.dataset.delay ) {
                options.delay = $interstitial.dataset.delay;
            }
            if($interstitial.dataset.scroll) {
                options.scroll = $interstitial.dataset.scroll;
            }

            if(options.delay) {
                setTimeout( () => {
                    $.fancybox.open({
                        src  : `#${$interstitial.id}`,
                        type : 'inline',
                        opts : {
                            modal: false,
                            btnTpl: {
                                close: ''
                            }
                        }
                    });
                    sessionStorage.setItem(`${$interstitial.id}`, 'open');
                }, (options.delay * 1000))

                const $close = $interstitial.querySelector('.js-interstitial__close');

                $close.addEventListener('click', () => {
                    $.fancybox.close();
                })

            }
        })
    }
}
